import { useEffect, useState } from 'react';

import type { MarketingTemplatePreset } from 'src/app/queries/marketing/campaign-templates/get-campaign-templates';

export function useDebounce(value: string, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export function doesTemplateHaveContent(template: MarketingTemplatePreset | null) {
  return (
    template?.HtmlBody && template?.JsonBody && template?.HtmlBody.trim() !== '' && template?.JsonBody.trim() !== ''
  );
}
